import MainMenu from 'components/common/mainmenu';
import React from 'react';
import StickyMenu from "components/common/stickymenu"
import StatsMenu from "components/common/statsmenu"
import SwitchTab from './SwitchTab'
export default ({ router }) => {

    return (
        <div className="livefeed-page overwrite--modal--depth">
            <StickyMenu withStickyHeader={false}>
                <MainMenu overviewIsActive={false} comparisonIsActive={false} onlyLeftMenu={true} />
                <StatsMenu leftItemBold="Livefeed settings" />
            </StickyMenu>
            <div className="page-content page-content_padding-modifier page-content_livefeed">
                <SwitchTab router={router} />
            </div >
        </div >
    )
}



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/index.jsx